import { File } from '@phosphor-icons/react';

export default File;